import type { ReactNode } from 'react';

import type { ChartDatapoint } from '../types/chart-data.js';

/**
 * @internal
 */
export type TooltipProps<TData extends ChartDatapoint = ChartDatapoint> = {
  hidden?: boolean;
  children?: (payload: TData) => ReactNode;
};

/**
 * @internal
 */
export const Tooltip = <T extends TooltipProps>(prefix: string) => {
  const component = (props: T) => null;
  component['displayName'] = `${prefix}.Tooltip`;

  return component;
};
